import {queryBearerToken} from "./UserAuthentication";
import * as ActionTypes from "../constants/ActionTypes";
import {queryArticleOptionData, queryBaseArticle} from "./ArticleData";
import {appInitialized} from "./AppInit";
import {_configuratorMode} from "../selectors/GetParam";
import {agencyServerArticleNumber, agencyServerCMSArticles, cmsArticles, devProjectArticleNumber, getArticleConfiguratorData, shopArticles} from "../config/Config";
import {ARTICLE_CONFIGURATOR_MODE_CMS, ARTICLE_CONFIGURATOR_MODE_SHARED, ARTICLE_CONFIGURATOR_MODE_SHOP, ARTICLE_TYPE_CMS, ARTICLE_TYPE_DEV, ARTICLE_TYPE_SHOP, PROJECT_STATE_DEV, PROJECT_STATE_LIVE} from "../constants/General";
import {initialize as initializeForms} from "redux-form";

export const initializeConfigurator = () => (dispatch, getState) => {

    const configurationMode = [
        ARTICLE_CONFIGURATOR_MODE_SHOP,
        ARTICLE_CONFIGURATOR_MODE_CMS,
        ARTICLE_CONFIGURATOR_MODE_SHARED
    ].indexOf(_configuratorMode) >= 0 ? _configuratorMode : 'shared';

    Promise.all([
        dispatch(queryBearerToken())
    ]).then((args) => {
        if (args[0].type !== ActionTypes.BEARER_TOKEN_FAILURE) {

            const initialCalls = configurationMode === 'shared' ? [
                queryBaseArticle(agencyServerArticleNumber),
            ] : [];

            Promise.all(initialCalls.map(func => dispatch(func))).then((args) => {
                if (args.length === 0 || args[0].type === ActionTypes.BASE_ARTICLE_SUCCESS) {

                    const configuration = getArticleConfiguratorData(getState())[configurationMode];

                    let neededArticleData = [];

                    Object.keys(configuration.projectStates).forEach(projectStateKey => {
                        const projectState = configuration.projectStates[projectStateKey];
                        Object.keys(projectState.projectTypes).forEach(projectTypeKey => {
                            const projectType = projectState.projectTypes[projectTypeKey];
                            neededArticleData = [
                                ...projectType.articles,
                                ...neededArticleData
                            ];
                        })
                    });

                    Promise.all([
                        // iterate through articleOptions and load data if price not available
                        dispatch(queryArticleOptionData(
                            [
                                ...neededArticleData,
                                ...(Object.keys(getState().articleData.articleOptions).filter(key => {
                                    return (key.includes("default") || getState().articleData.articleOptions[key].price) ? null : key
                                }))
                            ]
                        ))
                    ]).then((args) => {

                        switch (_configuratorMode) {

                            case ARTICLE_CONFIGURATOR_MODE_SHARED:
                                dispatch(initializeForms('projectSelection',
                                    {
                                        type: ARTICLE_TYPE_CMS,
                                        state: PROJECT_STATE_LIVE,
                                        article: "" + agencyServerCMSArticles[2],
                                        storage: "",
                                        backup: 7,
                                    }
                                ))
                                break;

                            case ARTICLE_CONFIGURATOR_MODE_CMS:
                                dispatch(initializeForms('projectSelection',
                                    {
                                        type: ARTICLE_TYPE_CMS,
                                        state: PROJECT_STATE_LIVE,
                                        article: "" + cmsArticles[1],
                                        storage: "",
                                        backup: 7,
                                    }
                                ))
                                break;

                            case ARTICLE_CONFIGURATOR_MODE_SHOP:
                                dispatch(initializeForms('projectSelection',
                                    {
                                        type: ARTICLE_TYPE_SHOP,
                                        state: PROJECT_STATE_LIVE,
                                        article: "" + shopArticles[1],
                                        storage: "",
                                        backup: 7,
                                    }
                                ))
                                break;

                        }
                        dispatch(appInitialized())
                    })
                }
            })
        }
    })
}



/** WEBPACK FOOTER **
 ** ./src/actions/AppInit.Configurator.js
 **/